<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>短剧列表</h3>
      <el-row class="add_btn"
        ><el-button type="success" icon="el-icon-plus" size="mini" @click="addVideo"
          >添加短剧</el-button
        ></el-row
      >
      <el-row
        style="
          margin: 15px 0px;
          font-size: 14px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        "
      >
        <span class="label">域名/包名</span>
        <el-select
          v-model="domain"
          placeholder="请选择域名"
          size="mini"
          clearable
          @change="domainChange"
          @keyup.enter.native.prevent
        >
          <el-option
            v-for="(item, index) in domainList"
            :key="index"
            :label="item.dm"
            :value="item.dm"
          ></el-option>
        </el-select>
        <span class="label" style="margin-left: 15px">App</span>
        <el-select
          v-model="domain"
          placeholder="请选择App"
          size="mini"
          clearable
          @change="domainChange"
          @keyup.enter.native.prevent
        >
          <el-option
            v-for="(item, index) in appList"
            :key="index"
            :label="item.appName"
            :value="item.packageName"
          ></el-option>
        </el-select>

        <span class="label" style="margin-left: 30px">语言</span>
        <el-select
          v-model="lang"
          placeholder="请选择语言"
          size="mini"
          clearable
          @change="langChange"
          @keyup.enter.native.prevent
        >
          <el-option
            v-for="(item, index) in langs"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <span class="label" style="margin-left: 30px">是否启用</span>
        <el-select
          v-model="videoSearch.enabled"
          placeholder="请选择是否启用"
          size="mini"
          clearable
          @change="enabledChange"
          @keyup.enter.native.prevent
        >
          <el-option label="启用" value="1"></el-option>
          <el-option label="未启用" value="0"></el-option>
        </el-select>
        <span class="label" style="margin-left: 30px">短剧名称</span>
        <el-input
          style="width: 220px"
          type="text"
          v-model="videoSearch.movieName"
          size="mini"
          placeholder="请输入短剧名称"
          @change="videoSearchChange"
          @keyup.enter.native.prevent
        ></el-input>
        <el-button
          type="danger"
          size="mini"
          style="margin: 0 5px 0 25px"
          @click="addMovieToDm"
          >批量加入域名/App</el-button
        >
        <el-button type="warning" size="mini" @click="addVastLinkToApp"
          >App添加vastLink</el-button
        >
      </el-row>
      <el-table
        :data="videoList"
        v-loading="loading"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column
          label="短剧名称"
          prop="movieName"
          align="center"
          width="200"
        ></el-table-column>
        <!-- -->
        <el-table-column
          label="排序"
          prop="sortNumber"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          label="语言"
          prop="lang"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          label="总集数"
          prop="totalEpisode"
          align="center"
        ></el-table-column>
        <el-table-column
          label="免费集数"
          prop="freeEpisode"
          align="center"
        ></el-table-column>
        <el-table-column
          label="解锁金币"
          prop="coinPrice"
          align="center"
        ></el-table-column>
        <el-table-column
          label="递增金币"
          prop="coinRate"
          align="center"
        ></el-table-column>
        <el-table-column label="播放量" prop="playCount" align="center"></el-table-column>
        <el-table-column
          label="短剧分类"
          prop="categoryNameList"
          align="center"
        ></el-table-column>
        <el-table-column label="短剧封面" align="center">
          <template slot-scope="scope">
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.cover"
              placement="top"
            >

              <span class="table_span">{{ scope.row.cover }}</span>
             <img :src="scope.row.cover"  alt="" srcset="" style="height:60px;">
            </el-tooltip> -->
            <img :src="scope.row.cover" alt="" srcset="" style="height: 100px" />
            <!-- <el-popover
                placement="top"
                max-width="35%"
                trigger="hover">
                <img :src="scope.row.cover"  alt="" srcset="">
                <el-button slot="reference" type="text" size="mini">hover查看</el-button>
              </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column label="是否启用" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.enabled ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否热播" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.hot ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否推荐" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.recommend ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="标签列表"
          prop="tagNameList"
          align="center"
        ></el-table-column>
        <el-table-column label="短剧概要" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.summary"
              placement="top"
            >
              <span class="table_span">{{ scope.row.summary }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="作者"
          prop="author"
          align="center"
          width="120"
        ></el-table-column>
        <!-- <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="580">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="shareHtml(scope.row)"
              >分享</el-button
            >
            <el-button type="primary" size="mini" @click="updateVideo(scope.row)"
              >更新</el-button
            >
            <el-button type="warning" size="mini" @click="checkEpisodeForThis(scope.row)"
              >查看剧集</el-button
            >
            <el-button type="success" size="mini" @click="addEpisodeForThis(scope.row)"
              >添加剧集</el-button
            >
            <el-button type="danger" size="mini" @click="removeFromDm(scope.row)"
              >从域名移除</el-button
            >
            <el-button type="danger" size="mini" @click="deleteVideo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="videoSearch.currentPage"
        :page-sizes="[50, 100, 200]"
        :page-size="videoSearch.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-dialog
        :title="string + '短剧'"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        top="0"
      >
        <el-form
          :model="addVideoForm"
          class="search_parent"
          size="mini"
          :rules="rules"
          label-width="120px"
          ref="ruleForm"
          @submit.native.prevent
        >
          <el-form-item label="作者" prop="author">
            <el-input
              v-model="addVideoForm.author"
              placeholder="请输入作者名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="短剧名称" prop="movieName">
            <el-input
              v-model="addVideoForm.movieName"
              placeholder="请输入短剧名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="语言" prop="movieName">
            <el-input
              v-model="addVideoForm.lang"
              placeholder="请输入语言(如:zh,en,ru等)"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="免费集数" prop="freeEpisode">
            <el-input
              v-model="addVideoForm.freeEpisode"
              placeholder="请输入免费集数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="需要金币数" prop="coinPrice">
            <el-input
              v-model="addVideoForm.coinPrice"
              placeholder="请输入需要金币数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="金币递增数" prop="coinRate">
            <el-input
              v-model="addVideoForm.coinRate"
              placeholder="请输入需要金币数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="上传封面">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadCover"
              accept=".jpg,.png,.webp"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImg"
              :file-list="fileList1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>

            <el-image
              :src="addVideoForm.cover"
              fit="cover"
              style="width: 100px; margin-left: 15px"
            ></el-image>
          </el-form-item>
          <el-form-item label="封面" prop="cover">
            <el-input
              v-model="addVideoForm.cover"
              clearable
              placeholder="请输入短剧封面链接"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传封面大图">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadLargeCover"
              accept=".jpg,.png,.webp"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImgLarge"
              :file-list="fileList2"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <el-image
              :src="addVideoForm.largeCover"
              fit="cover"
              style="width: 100px; margin-left: 15px"
            ></el-image>
          </el-form-item>
          <el-form-item label="封面大图">
            <el-input
              v-model="addVideoForm.largeCover"
              clearable
              placeholder="请输入短剧封面链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="landingLink">
            <el-input
              v-model="addVideoForm.landingLink"
              clearable
              placeholder="请输入短剧对应的landingLink"
            ></el-input>
          </el-form-item>
          <el-form-item label="VAST链接">
            <el-input
              v-model="addVideoForm.vastLink"
              clearable
              placeholder="请输入短剧对应的VAST链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="短剧集数" prop="totalEpisode">
            <el-input
              v-model="addVideoForm.totalEpisode"
              autocomplete="off"
              clearable
              placeholder="请输入短剧总集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="短剧分类" prop="categoryIdList">
            <el-select
              v-model="addVideoForm.categoryIdList"
              multiple
              placeholder="请选择短剧分类"
              clearable
              style="width: 60%"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="'key_' + index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-input
              v-model="addVideoForm.sortNumber"
              autocomplete="off"
              clearable
              placeholder="请输入短剧总集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-select
              v-model="addVideoForm.enabled"
              placeholder="请选择是否启用"
              clearable
              style="width: 60%"
            >
              <el-option :value="1" label="启用"></el-option>
              <el-option :value="0" label="不启用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否热播">
            <el-select
              v-model="addVideoForm.hot"
              placeholder="请选择是否热播"
              clearable
              style="width: 60%"
            >
              <el-option :value="1" label="是"></el-option>
              <el-option :value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否推荐">
            <el-select
              v-model="addVideoForm.recommend"
              placeholder="请选择是否推荐"
              clearable
              style="width: 60%"
            >
              <el-option :value="1" label="是"></el-option>
              <el-option :value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短剧标签">
            <el-select
              v-model="addVideoForm.tagNameList"
              placeholder="请选择标签"
              multiple
              clearable
              style="width: 60%"
            >
              <el-option
                v-for="(item, index) in tagNameListPage"
                :key="index"
                :value="item"
                :label="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短剧概要">
            <el-input
              v-model="addVideoForm.summary"
              autocomplete="off"
              type="textarea"
              :rows="5"
              placeholder="请输入短剧概要"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitVideoForm('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="dialogFormVisible1"
        width="85%"
        top="3vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <episodeManager :id="videoId" :movieName="movieName"></episodeManager>
      </el-dialog>

      <el-dialog
        :title="string + '剧集'"
        :visible.sync="dialogFormVisible2"
        :close-on-click-modal="false"
        label-width="120px"
      >
        <el-form
          :model="addEpisodeForm"
          class="search_parent"
          size="mini"
          top="0"
          label-width="120px"
          @submit.native.prevent
        >
          <el-form-item label="集数">
            <el-input
              v-model="addEpisodeForm.episode"
              placeholder="请输入当前视频在短剧中的集数"
            ></el-input>
          </el-form-item>
          <el-form-item label="分集名称">
            <el-input
              v-model="addEpisodeForm.episodeName"
              autocomplete="off"
              placeholder="请输入当前视频名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传视频">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              accept=".mp4"
              :auto-upload="true"
              :headers="{ Authorization: token }"
              :show-file-list="true"
              ref="uploadVideo"
              :on-success="handleAvatarSuccess"
              :file-list="fileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传mp4文件</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频链接">
            <el-input v-model="addEpisodeForm.url" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="视频大小">
            <el-input v-model="addEpisodeForm.size" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="视频类型">
            <el-input v-model="addEpisodeForm.fileExt" placeholder=""></el-input>
          </el-form-item>

          <el-form-item label="图片">
            <el-input
              v-model="addEpisodeForm.image"
              placeholder="请选输入图片链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否需要广告">
            <el-select v-model="addEpisodeForm.needAd">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否需要付费">
            <el-select v-model="addEpisodeForm.needPay">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金币">
            <el-input
              v-model="addEpisodeForm.payPrice"
              placeholder="请选输入支付金币"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="submitAddEpisodeForm">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="添加vast链接"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :visible.sync="vastVisible"
      >
        <el-form :model="vastForm" size="mini" label-width="120px" @submit.native.prevent>
          <el-form-item label="vast链接">
            <el-input v-model="vastForm.vastLink" placeholder="请输入vast链接"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="sureAddVastLink"
              >确定</el-button
            >
            <el-button @click="vastVisible = false" size="mini">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog
        title="App添加Vast链接"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :visible.sync="appVisible"
      >
        <el-form
          :model="appVastForm"
          size="mini"
          label-width="120px"
          @submit.native.prevent
        >
          <el-form-item label="vast链接">
            <el-input
              v-model="appVastForm.vastLink"
              placeholder="请输入vast链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="app包名">
            <!-- <el-input v-model="appVastForm.vastLink" placeholder="请输入vast链接"></el-input> -->
            <el-select v-model="appVastForm.domain">
              <el-option
                v-for="(item, index) in appList"
                :key="index"
                :label="item.appName"
                :value="item.packageName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="sureAddAppVastLink"
              >确定</el-button
            >
            <el-button @click="appVisible = false" size="mini">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
import episodeManager from "./episodeManager.vue";
export default {
  components: { episodeManager },
  data() {
    return {
      videoId: 0,
      movieName: "",
      appName: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      total: 0,
      videoList: [],
      categoryList: [],
      videoSearch: {
        categoryId: "",
        currentPage: 1,
        enabled: "",
        endTime: "",
        hot: "",
        movieName: "",
        pageSize: 50,
        recommend: "",
        startTime: "",
        type: "ShortVideo",
        domain: "",
        vastLink: "",
        lang: "",
      },
      lang: "",
      langs: [
        {
          id: 0,
          value: "en",
          label: "英语",
        },
        {
          id: 1,
          value: "pt",
          label: "葡语",
        },
        {
          id: 2,
          value: "ru",
          label: "俄语",
        },
      ],
      dialogFormVisible: false,
      string: "添加",
      loading: false,
      rules: {
        coinPrice: [
          { required: true, message: "请输入解锁视频所需金币数量", trigger: "blur" },
        ],
        freeEpisode: [{ required: true, message: "请输入短剧免费集数", trigger: "blur" }],
        coinRate: [
          { required: true, message: "请输入解锁视频金币递增数量", trigger: "blur" },
        ],
        author: [{ required: true, message: "请输入作者名称", trigger: "blur" }],
        movieName: [{ required: true, message: "请输入短剧名称", trigger: "blur" }],
        cover: [{ required: true, message: "请输入封面大图链接", trigger: "blur" }],
        largeCover: [{ required: true, message: "请输入封面大图链接", trigger: "blur" }],
        categoryIdList: [{ required: true, message: "请选择短剧分类", trigger: "blur" }],
        totalEpisode: [
          { required: true, message: "请输入短剧集数", trigger: "blur" },
          {
            pattern: /^(\d+|\d*\\d{1,10})$/,
            message: "短剧集数只能是整数",
            trigger: "blur",
          },
        ],
      },
      addVideoForm: {
        author: "",
        lang: "en",
        categoryIdList: [],
        country: "",
        cover: "",
        enabled: 1,
        hot: 1,
        movieName: "",
        publishBy: "",
        publishByName: "",
        publishTime: "",
        recommend: 0,
        summary: "",
        tagNameList: [],
        totalEpisode: "",
        type: "ShortVideo",
        largeCover: "",
        vastLink: "",
        coinPrice: 0,
        coinRate: 0,
        freeEpisode: 1,
        sortNumber: 0,
        landingLink: "",
      },
      tagNameListPage: [
        "Love After Divorce",
        "Love After Marriage",
        "Taboo",
        "Fated Lovers",
        "Flash Marriage",
        "Revenge",
        "Enemies to Lovers",
        "Werewolf",
        "Friends to Lovers",
        "Fantasy",
      ],
      edit: false,
      addEpisodeForm: {
        episode: "",
        episodeName: "",
        fileExt: "",
        image: "",
        movieId: "",
        needAd: "",
        needPay: "",
        payPrice: "",
        size: "",
        summary: "",
        url: "",
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      token: JSON.parse(sessionStorage.getItem("loginData")).token,
      multipleSelection: [],
      domainList: [],
      appList: [],
      domain: "",
      vastVisible: false,
      vastForm: {
        vastLink: "",
      },
      appVastForm: {
        vastLink: "",
        domain: "",
      },
      appVisible: false,
      appList: [],
      domainMovielist: [],
    };
  },
  methods: {
    sureAddAppVastLink() {
      if (this.appVastForm.vastLink && this.appVastForm.domain) {
        let movieIds = [];
        this.multipleSelection.forEach((item) => {
          movieIds.push(item.id);
        });
        axiosPost(
          "/api/movie/add_domain",
          {
            domain: this.appVastForm.domain,
            vastLink: this.appVastForm.vastLink,
            movieId: movieIds.join(","),
          },
          "JSON"
        ).then((res) => {
          if (res.code == 0) {
            this.appVisible = false;
            this.appVastForm = {
              vastLink: "",
              domain: "",
            };
            this.domainChange();
          }
        });
      } else {
        return false;
      }
    },
    isPackageName(str) {
      // Android包名规则：只能包含小写字母、数字、点（.）和下划线（_），并且不能以数字开头，长度在1-127个字符之间
      const packageNameRegex = /^[a-z][a-z\d_]*\.[a-z][a-z\d_]*([a-z][a-z\d_]*)*$/;
      return packageNameRegex.test(str) && str.length <= 127;
    },
    addVastLinkToApp() {
      if (!this.multipleSelection.length) {
        this.$message({ message: "请至少选择一个短剧", type: "error" });
        return false;
      }
      axiosGet("/api/app_web/list").then((res) => {
        if (res.code == 0) {
          this.appList = res.data.records;
          this.appVisible = true;
        }
      });
    },
    async sureAddVastLink() {
      this.loading = true;
      this.vastVisible = false;
      let movieIds = [];
      this.multipleSelection.forEach((item) => {
        movieIds.push(item.id);
      });
      await axiosPost(
        "/api/movie/add_domain",
        {
          domain: this.domain,
          movieId: movieIds.join(","),
          vastLink: this.vastForm.vastLink,
        },
        "JSON"
      ).then((res) => {
        if (res.code == 0) {
          movieIds = [];
          this.$refs.multipleTable.clearSelection();
        }
      });
      if (this.appList.find((item) => item.packageName == this.domain)) {
        this.$message({ message: "视频加入域名成功,JSON文件生成成功", type: "success" });
        this.domainChange(this.domain);
        return false;
      }
      await axiosPost(
        "/api/movie/make/list_json",
        { domain: this.domain, lang: "en" },
        "JSON"
      ).then((res) => {
        if (res.code == 0) {
          movieIds = [];
          this.$refs.multipleTable.clearSelection();
          // this.$message({message:"视频加入域名成功,JSON文件生成成功",type:"success"});
        }
      });
      await axiosPost(
        "/api/movie/make/list_recommend_hot_json",
        { domain: this.domain, lang: "en", type: "recommend" },
        "JSON"
      ).then((res) => {
        if (res.code == 0) {
          movieIds = [];
          this.$refs.multipleTable.clearSelection();
          this.$message({
            message: "视频加入域名成功,JSON文件生成成功",
            type: "success",
          });
        }
      });
      this.domainChange(this.domain);
    },
    async addMovieToDm() {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
        return false;
      }
      if (!this.multipleSelection.length) {
        this.$message({ message: "请至少选择一个短剧", type: "error" });
        return false;
      } else {
        this.vastVisible = true;
      }
    },
    removeMovieToDm() {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
        return false;
      }
      if (!this.multipleSelection.length) {
        this.$message({ message: "请至少选择一个短剧", type: "error" });
        return false;
      } else {
        let movieIds = [];
        this.multipleSelection.forEach((item) => {
          movieIds.push(item.id);
        });
        // axiosPost('/api/movie/add_domain',{domain:this.domain,movieId:movieIds.join(",")},"JSON").then(res=>{
        //   if(res.code==0){
        //     movieIds=[];
        //     this.$refs.multipleTable.clearSelection();
        //     this.$message({message:"视频加入域名成功",type:"success"});
        //   }
        // })
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAvatarSuccessImgLarge(res) {
      if (res.code == 0) {
        this.addVideoForm.largeCover = res.data.url;
        this.$forceUpdate(); // 强制更新页面上的表单内容
        this.$refs.uploadLargeCover.clearFiles();
      }
    },
    handleAvatarSuccessImg(res) {
      if (res.code == 0) {
        this.addVideoForm.cover = res.data.url;
        this.$refs.uploadCover.clearFiles();
        this.$forceUpdate();
        // this.$refs.uploadLargeCover.clearFiles();
      }
      // this.addVideoForm.cover=
    },
    handleAvatarSuccess(res) {
      if (res.code == 0) {
        this.addEpisodeForm.url = res.data.url;
        this.addEpisodeForm.size = res.data.size;
        this.addEpisodeForm.fileExt = res.data.ext;
        this.$refs.uploadVideo.clearFiles();
      }
    },
    async getDomainList() {
      await axiosGet("/api/domains/list", {
        currentPage: 1,
        pageSize: 50,
        dmType: 3,
      }).then((res) => {
        if (res.code == 0) {
          this.domainList = res.data.records;
        }
      });
    },
    async getAppList() {
      await axiosGet("/api/app_web/list", {
        currentPage: 1,
        pageSize: 50,
        dmType: 3,
      }).then((res) => {
        if (res.code == 0) {
          this.appList = res.data.records;
        }
      });
    },
    submitAddEpisodeForm() {
      axiosPost("/api/movie/episode/add", this.addEpisodeForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "添加剧集成功", type: "success" });
          this.dialogFormVisible2 = false;
        }
      });
    },
    addEpisodeForThis(row) {
      this.addEpisodeForm.movieId = row.id;
      this.dialogFormVisible2 = true;
    },
    async getList(params, total) {
      this.loading = true;
      let copyParams = {
        categoryId: "",
        currentPage: params.currentPage || 1,
        enabled: params.enabled || "",
        endTime: "",
        hot: "",
        movieName: params.movieName || "",
        pageSize: params.pageSize || 50,
        recommend: "",
        startTime: "",
        type: "ShortVideo",
        domain: "",
        vastLink: "",
        lang: params.lang || "en",
      };
      await axiosGet("/api/movie/list", copyParams).then((res) => {
        if (res.code == 0) {
          this.videoList = res.data.records;
          this.total = res.data.total;
          this.$nextTick(() => {
            this.domainMovielist.forEach((item) => {
              const matchedRow = this.videoList.find((row) => row.id === item.id);
              if (matchedRow) {
                this.$refs.multipleTable.toggleRowSelection(matchedRow, true);
              }
            });
          });
        }
      });
      this.loading = false;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    checkEpisodeForThis(row) {
      this.videoId = row.id;
      this.movieName = row.movieName;
      this.dialogFormVisible1 = true;
    },
    langChange(val) {
      this.videoSearch.lang = val;
      this.getList(this.videoSearch);
    },
    enabledChange(val) {
      this.videoSearch.enabled = val;
      console.log(this.videoSearch);
      this.getList(this.videoSearch);
    },
    deleteVideo(row) {
      this.$confirm("是否要删除 " + row.movieName + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/movie/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.getList(this.videoSearch);
              this.$message({ message: "删除成功", type: "success" });
            }
          });
        })
        .catch(() => {});
    },
    addVideo() {
      this.edit = false;
      this.string = "添加";
      this.addVideoForm = {
        author: "",
        lang: "en",
        categoryIdList: [],
        country: "",
        cover: "",
        enabled: 1,
        hot: 1,
        movieName: "",
        publishBy: "",
        publishByName: "",
        publishTime: "",
        recommend: 0,
        summary: "",
        tagNameList: [],
        totalEpisode: "",
        type: "ShortVideo",
        largeCover: "",
        vastLink: "",
        coinPrice: 0,
        coinRate: 0,
        freeEpisode: 1,
        landingLink: "",
        sortNumber: 0,
      };
      this.dialogFormVisible = true;
    },
    updateVideo(row) {
      let rowData = "";
      if (this.domainMovielist.length) {
        this.domainMovielist.forEach((item) => {
          if (item.id === row.id) {
            rowData = item;
          }
        });
      } else {
        rowData = row;
      }
      this.addVideoForm = {
        author: rowData.author,
        categoryIdList: rowData.categoryIdList,
        cover: rowData.cover,
        enabled: rowData.enabled || 0,
        hot: rowData.hot || 0,
        movieName: rowData.movieName,
        publishBy: "",
        publishByName: "",
        publishTime: "",
        recommend: rowData.recommend || 0,
        summary: rowData.summary,
        tagNameList: rowData.tagNameList,
        totalEpisode: rowData.totalEpisode,
        largeCover: rowData.largeCover,
        id: rowData.id,
        type: "ShortVideo",
        vastLink: rowData.vastLink || "",
        lang: rowData.lang || "en",
        coinPrice: rowData.coinPrice || 0,
        coinRate: rowData.coinRate || 0,
        freeEpisode: rowData.freeEpisode || 0,
        sortNumber: rowData.sortNumber || 0,
        landingLink: rowData.landingLink || "",
      };
      this.edit = true;
      this.string = "更新";
      this.dialogFormVisible = true;
    },
    getCategoryList() {
      this.loading = true;
      axiosGet("/api/movie/category/list").then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.categoryList = res.data;
          }

          this.loading = false;
        }
      });
    },
    async submitVideoForm(formName) {
      console.log(this.addVideoForm);
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        let url = this.edit ? "/api/movie/update" : "/api/movie/add";
        axiosPost(url, this.addVideoForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "短剧" + this.string + "成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList(this.videoSearch);
          }
        });
      }
    },
    videoSearchChange(val) {
      this.videoSearch.currentPage = 1;
      this.videoSearch.movieName = val;
      this.getList(this.videoSearch);
    },
    handleSizeChange(val) {
      this.videoSearch.pageSize = val;
      this.getList(this.videoSearch);
    },
    handleCurrentChange(val) {
      this.videoSearch.currentPage = val;
      this.getList(this.videoSearch);
    },
    addMovieToDomain(row) {
      // axiosPost('/api/movie/add_domain',{domain:"",})
    },
    shareHtml(row) {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
      } else {
        this.$alert(`https://${this.domain}/movies/movie-${row.id}.html`, "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    async domainChange(val) {
      this.loading = true;
      this.videoSearch.domain = val;
      if (this.videoSearch.domain) {
        this.videoSearch.pageSize = this.total;
        await axiosGet("/api/movie/list", this.videoSearch).then((result) => {
          if (result.code == 0) {
            if (result.data.records) {
              this.domainMovielist = result.data.records;
              this.getList(this.videoSearch);
            }
          }
        });
      } else {
        this.$refs.multipleTable.clearSelection();
        this.getList(this.videoSearch);
      }
    },
    removeFromDm(val) {
      if (!this.domain) {
        this.$message({ message: "请先选择域名", type: "error" });
        return false;
      }
      this.$confirm(`是否要从${this.domain}域名移除该视频?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost(
            "/api/movie/remove_domain",
            { domain: this.domain, movieIds: [val.id] },
            "JSON"
          ).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "视频移除域名成功,请从新生成JSON文件",
                type: "success",
              });
              this.getList(this.videoSearch);
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getCategoryList();
    this.domain = sessionStorage.getItem("needDm") || "";
    this.videoSearch.domain = this.domain;
    this.getList(this.videoSearch);
    this.getDomainList();
    this.getAppList();
  },
  destroyed() {
    sessionStorage.removeItem("needDm");
  },
  // 在 App.vue 或主组件中
  created() {
    window.addEventListener(
      "submit",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/videoManager/videoList.vue